import React from "react"
import { useTranslation } from "react-i18next"
// Styles
import { Container } from "./Announcement.styles"

const Announcement = () => {
    const { t } = useTranslation()

    return (
        <Container>
            {t("announcement.text.t1")}
        </Container>
    )
}

export default Announcement
